import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { generalSalesReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE_EMPLOYEE];

const generalSalesReportRouteMetadata: IRouteMetadataObj<
  typeof generalSalesReportRoutesObj
> = {
  list: {
    title: "seller.salesReport.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/generalSalesReport/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const generalSalesReportRoutes = createRoute<
  typeof generalSalesReportRoutesObj
>(generalSalesReportRoutesObj, generalSalesReportRouteMetadata);
